<template>
    <md-dialog :md-active.sync="showDialogGrupo" :md-click-outside-to-close="false" class="group-dialog">
        <md-dialog-title class="dialog-header">
            <span class="header-title">{{ labels.createGroup }}</span>
        </md-dialog-title>

        <md-dialog-content class="dialog-content">
            <div class="form-container">
                <b-row>
                    <b-col md="12">
                        <div class="form-group-custom">
                            <label class="label-custom">{{ labels.name }} <span class="required">*</span></label>
                            <md-field class="custom-field" :class="{ 'md-invalid': errors.nombre }">
                                <md-input
                                    type="text"
                                    name="name"
                                    v-model="nuevoGrupo.nombre"
                                    :placeholder="labels.name"
                                    @blur="validateField('nombre')"
                                />
                                <span class="error-message" v-if="errors.nombre">{{ errors.nombre }}</span>
                            </md-field>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </md-dialog-content>

        <md-dialog-actions class="dialog-actions">
            <div class="actions-right">
                <md-button class="md-raised cancel-btn" @click="clicked">
                    {{ labels.close }}
                </md-button>
                <md-button class="md-raised md-primary save-btn" @click="crearGrupo">
                    {{ labels.save }}
                </md-button>
            </div>
        </md-dialog-actions>
    </md-dialog>
</template>

<script>
    import Grupo from '@/services/Grupo'

    export default {
        name: "NewGrupo",
        props: ['showDialogGrupo'],

        data: () => ({
            nuevoGrupo: {
                nombre: ""
            },
            errors: {
                nombre: ""
            }
        }),

        watch: {
            showDialogGrupo(val) {
                if (val) {
                    this.resetForm();
                }
            }
        },

        computed: {
            labels(){
                if (this.$store.state._language == "es-ES") {
                    return {
                        createGroup: "Crear Grupo",
                        name: "Nombre",
                        save: "Guardar",
                        close: "Cerrar"
                    }
                } else {
                    return {
                        createGroup: "Create Group",
                        name: "Name",
                        save: "Save",
                        close: "Close"
                    }
                }
            }
        },

        methods: {
            resetForm() {
                this.nuevoGrupo = { nombre: "" };
                this.errors = { nombre: "" };
            },

            validateField(field) {
                const lang = this.$store.state._language;
                
                if (field === 'nombre') {
                    if (!this.nuevoGrupo.nombre) {
                        this.errors.nombre = lang == "es-ES" 
                            ? "El nombre del grupo es obligatorio" 
                            : "Group name is required";
                    } else if (this.nuevoGrupo.nombre.length < 3) {
                        this.errors.nombre = lang == "es-ES" 
                            ? "El nombre debe tener al menos 3 caracteres" 
                            : "Name must have at least 3 characters";
                    } else if (this.nuevoGrupo.nombre.length > 255) {
                        this.errors.nombre = lang == "es-ES" 
                            ? "El nombre no puede exceder los 255 caracteres" 
                            : "Name cannot exceed 255 characters";
                    } else {
                        this.errors.nombre = "";
                    }
                }
            },

            validateForm() {
                this.validateField('nombre');
                return !this.errors.nombre;
            },

            async crearGrupo() {
                if (!this.validateForm()) {
                    this.$toast.error(this.$store.state._language == "es-ES" 
                        ? "Por favor, corrija los errores del formulario" 
                        : "Please correct the form errors");
                    return;
                }

                try {
                    const userData = {
                        ...this.nuevoGrupo,
                        u_crea: this.$store.state.userId
                    };
                    
                    const res = await Grupo.create(userData);
                    
                    this.$toast.success(res.data.message || (this.$store.state._language == "es-ES" 
                        ? "Grupo creado exitosamente" 
                        : "Group created successfully"));
                    
                    this.resetForm();
                    this.$emit('clicked', false);
                    this.$emit('grupoCreado');
                    
                } catch (error) {
                    console.error("Error creating group:", error);
                    
                    let errorMessage = this.$store.state._language == "es-ES" 
                        ? "Error al crear el grupo" 
                        : "Error creating group";
                    
                    if (error.response && error.response.data) {
                        if (error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.data.error) {
                            errorMessage = error.response.data.error;
                        }
                    }
                    
                    this.$toast.error(errorMessage);
                }
            },

            clicked() {
                this.resetForm();
                this.$emit('clicked', false);
            }
        }
    }
</script>

<style scoped>
.group-dialog >>> .md-dialog {
    max-width: 500px;
    width: 90%;
    border-radius: 8px;
    overflow: hidden;
}

.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    margin: 0;
    border-bottom: 1px solid #2c3e50;
}

.header-title {
    font-size: 1.3rem;
    font-weight: 500;
}

.dialog-content {
    padding: 20px 24px;
    max-height: 70vh;
    overflow-y: auto;
}

.form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.form-group-custom {
    margin-bottom: 0;
}

.label-custom {
    display: block;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.required {
    color: #e74c3c;
}

.custom-field {
    margin: 0;
}

.md-field.md-invalid .md-input {
    border-color: #ff5252;
}

.error-message {
    color: #ff5252;
    font-size: 12px;
    margin-top: 4px;
    display: block;
}

.dialog-actions {
    padding: 20px 24px;
    border-top: 1px solid #ecf0f1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #f8f9fa;
}

.actions-right {
    display: flex;
    gap: 12px;
}

.cancel-btn {
    background: #95a5a6 !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.save-btn {
    background: #3498db !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.cancel-btn:hover {
    background: #7f8c8d !important;
}

.save-btn:hover {
    background: #2980b9 !important;
}

/* Scroll personalizado */
.dialog-content::-webkit-scrollbar {
    width: 8px;
}

.dialog-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Responsive */
@media (max-width: 768px) {
    .group-dialog >>> .md-dialog {
        width: 95%;
        margin: 16px;
    }
    
    .actions-right {
        width: 100%;
        flex-direction: column;
    }
    
    .cancel-btn, .save-btn {
        width: 100%;
        margin: 4px 0;
    }
}
</style>